/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @flow
 */
'use strict';

// Do not add requires here!
// Running module factories is intentionally delayed until we know the hook exists.
// This is to avoid issues like: https://github.com/facebook/react-devtools/issues/1039
window.installGlobalHook = require('../../../backend/installGlobalHook.js');

window.installBridge = function installBridge(store: Object){
  window.addEventListener('message', welcome);
  function welcome(evt) {
    if (evt.source !== window) {
      return;
    }

    window.removeEventListener('message', welcome);
    setup(window.__REACT_DEVTOOLS_GLOBAL_HOOK__, store);
  }
}

function setup(hook, store) {
  var Agent = require('../../../agent/Agent');
  var Bridge = require('../../../agent/Bridge');
  var inject = require('../../../agent/inject');

  var listeners = [];

  var wall = {
    listen(fn) {
      var listener = evt => {
        if (evt.source !== window || !evt.data  || !evt.data.payload) {
          return;
        }
        fn(evt.data.payload);
      };
      listeners.push(listener);
      window.addEventListener('message', listener);
    },
    send(data) {
      window.postMessage({
        source: 'lugia-theme-bridge',
        payload: data,
      }, '*');
    },
  };

  // Note: this is only useful for react-native-web (and equivalents).
  // They would have to set this field directly on the hook.

  var bridge = new Bridge(wall);
  store.lugiaBridge = bridge;
  var agent = new Agent(window, {
    rnStyle: false,
  });
  agent.addBridge(bridge);

  inject(hook, agent);


  agent.on('shutdown', () => {
    hook.emit('shutdown');
    listeners.forEach(fn => {
      window.removeEventListener('message', fn);
    });
    listeners = [];
  });

}
module.exports = {
  installGlobalHook,
  installBridge
};
